import React from 'react';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

import { EOfferFormatKey } from '../../../StoreSettings.types';
import {
  ABBREVIATION_OFFER_TABS,
  getAbbreviationTabTestId
} from '../AbbreviationsSettingsV2.consts';

interface IOfferTypeTabsProps {
  activeTab: EOfferFormatKey;
  onTabChange: (tab: EOfferFormatKey) => void;
}

export const OfferTypeTabs = ({
  activeTab,
  onTabChange
}: IOfferTypeTabsProps): React.ReactElement => (
  <Tabs
    value={activeTab}
    onValueChange={(value): void => onTabChange(value as EOfferFormatKey)}
  >
    <TabsList className="h-auto gap-[2px] bg-transparent p-0">
      {ABBREVIATION_OFFER_TABS.map((tab) => (
        <TabsTrigger
          key={tab.key}
          value={tab.key}
          className="rounded-md px-4 py-2 text-sm font-medium text-base-foreground data-[state=active]:bg-violet-50 data-[state=active]:text-base-foreground data-[state=active]:shadow-none"
          data-testid={getAbbreviationTabTestId(tab.key)}
        >
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
);
